<ng-container *ngIf="!catalogCard">
<div class="img-wrapper">
    <div class="lable-block">
        <span class="lable3" *ngIf="product.new">new</span>
        <span class="lable4" *ngIf="product.sale">on sale</span>
    </div>
    <div class="front">
        <a [routerLink]="productDetailLink()" [queryParams]="productDetailQueryParams()">
            <img [defaultImage]="ImageSrc ? ImageSrc : 'assets/images/product/placeholder.jpg'"
                 [lazyLoad]="heroImage(product)"
                 class="img-fluid lazy-loading" alt="">
        </a>
    </div>
    <div class="cart-box">
        <a href="javascript:void(0)" title="Vista rápida" (click)="QuickView.openModal()">
            <i class="ti-search" aria-hidden="true"></i>
        </a>
        <a href="javascript:void(0)" title="Comparar" (click)="addToCompare(product)">
            <i class="ti-reload" aria-hidden="true"></i>
        </a>
    </div>
</div>
<div class="product-detail text-center" [class.catalog-product-detail]="homeCard">
    <ng-container *ngIf="homeCard; else defaultProductDetail">
        <ng-container *ngTemplateOutlet="tecbazarProductDetail"></ng-container>
    </ng-container>
    <ng-template #defaultProductDetail>
        <div class="rating">
            <bar-rating [rate]="5" [readOnly]="true" class="text-center pro-rating"></bar-rating>
        </div>
        <a [routerLink]="productDetailLink()" [queryParams]="productDetailQueryParams()">
            <h6>{{ product.title | titlecase }}</h6>
        </a>
        <p class="product-sku" *ngIf="showSku && productSku()">{{ productSku() }}</p>
        <h4>
            {{ product?.price * currency?.price | discount:product | currency:currency?.currency:'symbol' }}
            <del *ngIf="product?.discount"><span class="money"> {{ product?.price * currency?.price | currency:currency?.currency:'symbol' }}</span></del>
        </h4>
        <ul class="color-variant" *ngIf="Color(product?.variants).length">
          <li [class]="color" *ngFor="let color of Color(product?.variants)" [ngStyle]="{'background-color': color}"
              (click)="ChangeVariants(color, product)"></li>
        </ul>
    </ng-template>
</div>
</ng-container>

<!-- Catálogo TecBazar: jerarquía tipo grid central /shop/collection -->
<ng-container *ngIf="catalogCard">
<div class="img-wrapper">
    <div class="lable-block catalog-lable-block">
        <span class="lable3" *ngIf="product.new">new</span>
    </div>
    <div class="front">
        <a [routerLink]="productDetailLink()" [queryParams]="productDetailQueryParams()">
            <img [defaultImage]="'assets/images/product/placeholder.jpg'"
                 [lazyLoad]="heroImage(product)"
                 class="img-fluid lazy-loading catalog-product-img"
                 alt="">
        </a>
    </div>
    <div class="cart-box">
        <a href="javascript:void(0)" title="Vista rápida" (click)="QuickView.openModal()">
            <i class="ti-search" aria-hidden="true"></i>
        </a>
        <a href="javascript:void(0)" title="Comparar" (click)="addToCompare(product)">
            <i class="ti-reload" aria-hidden="true"></i>
        </a>
    </div>
</div>
<div class="product-detail text-center catalog-product-detail">
    <ng-container *ngTemplateOutlet="tecbazarProductDetail"></ng-container>
</div>
</ng-container>

<ng-template #tecbazarProductDetail>
    <a class="catalog-title-link" [routerLink]="productDetailLink()" [queryParams]="productDetailQueryParams()">
        <h6 class="catalog-title">{{ product.title | titlecase }}</h6>
    </a>
    <div class="catalog-free-shipping">
        <span class="catalog-free-shipping-badge">Envío Gratis</span>
    </div>
    <h4 class="precio-catalog-contado">Contado a {{ effectivePrice(product) | currency:currency?.currency:'symbol':'1.2-2' }}</h4>
    <div class="catalog-plan-lines">
        <span class="txt-plan">Hasta 12 mensualidades</span>
        <span class="catalog-plan-conditions">
            Consultar condiciones
            <a
                href="javascript:void(0)"
                class="catalog-plan-link"
                (click)="openBanksConditionsClick($event)"
            >aquí</a>
        </span>
    </div>
    <ul class="color-variant" *ngIf="Color(product?.variants).length">
      <li [class]="color" *ngFor="let color of Color(product?.variants)" [ngStyle]="{'background-color': color}"
          (click)="ChangeVariants(color, product)"></li>
    </ul>
</ng-template>

<app-quick-view #quickView [product]="product" [currency]="currency"></app-quick-view>
<app-cart-modal #cartModal [product]="product" [currency]="currency" *ngIf="cartModal"></app-cart-modal>
